import React, { Component } from 'react'
import Creater from '../../controller/Creater'
import Updater from '../../controller/Updater'
import Deleter from '../../controller/Deleter'
import Alert from '../etc/Alert'

export default class CalendarCell extends Component {

    state = {
        isToday : false,
        task : '',
        isNew : false,
        isAlert : false,
        alertTxt : ''
    }
    

    componentWillReceiveProps(nextProps) {

        let today = new Date()
        let year = today.getFullYear()
        let month = today.getMonth()
        let date = today.getDate()

        let task = nextProps.plan

        if(task === null || task === '' || task === undefined) {

            this.setState({ isNew : true })
        
        } else {

            this.setState({ isNew : false })

        }
        
        if(nextProps.year === year && nextProps.month === month && nextProps.date === date) {

            this.setState({ 
                isToday : true,
                task : task
            })

        } else {
            
            this.setState({ 
                isToday : false,
                task : task
            })

        }
    }
  

    changeFx = (e) => {

        this.setState({ task : e.target.value })

    }


    enterFx = (e) => {
      
        let keyNum = e.key

        switch(true) {

            case keyNum === 'Enter' && this.state.isNew === false && this.state.task === '':
                this.deleteFx()
                break

            case keyNum === 'Enter' && this.state.isNew === true :
                this.addFx()
                break

            case keyNum === 'Enter' && this.state.isNew === false :
                this.updateFx()
                break      

            default : 
                break
            
        }

    }


    addFx = () => {

        let postIt = {
            url : '/api/calendar/add',
            data : {
                '_id' : this.props.year * 10000 + this.props.month * 100 + this.props.date,
                'year' : this.props.year,
                'month' : this.props.month,
                'date' : this.props.date - 1,
                'task' : this.state.task
            }
        }
        
        Creater(postIt, res => {

            if(res.message === 'blocked' || res.message === 'ERROR') {
        
                this.setState({ 
                    alertTxt : 'Access Denied!',
                    isAlert : true
                })
                
                return
            
            } else {

                this.setState({ 
                    isAlert : true,
                    alertTxt : res.message
                })

            }
        })
		
    }


    updateFx = () => {

		let idName = this.props.year * 10000 + this.props.month * 100 + this.props.date
        
        let condition = {
            url : '/api/calendar/update/' + idName,
            data : {
                task : this.state.task
            }
        }
        
		Updater(condition, res => {

            if(res.message === 'blocked' || res.message === 'ERROR') {
        
                this.setState({ 
                    alertTxt : 'Fail to Update!',
                    isAlert : true
                })
                
                return

            } else {

                this.setState({ 
                    isAlert : true,
                    alertTxt : res.message
                })

            }

        })
    }
    

    deleteFx = () => {

        let idName = this.props.year * 10000 + this.props.month * 100 + this.props.date

        let condition = {
            url : '/api/calendar/delete/' + idName
        }

        Deleter(condition, res => {

            if(res.message === 'blocked' || res.message === 'ERROR') {
        
                this.setState({ 
                    alertTxt : 'Fail to Delete!',
                    isAlert : true
                })
                
                return
                
            } else {

                this.setState({ 
                    isAlert : true,
                    alertTxt : res.message
                })

            }
        
        })
    }

    
    closeFx = () => {

        this.setState({ isAlert : false })
    }
    

    render() {

        return(

            <React.Fragment>
                
                { this.state.isAlert ? <Alert alert={this.state.alertTxt} closeMe = { this.closeFx } /> : null }

                <div className={ this.props.isOverflow ? 'CalCell2' : 'CalCell' } style={{ borderBottom: this.state.isToday ? '8px solid #22252C' : '1px solid #AE9A8A' }} >
                    
                    <span className='calendarDate'>
                    
                        { this.props.date } { this.state.isToday ? 'TODAY' : null }
                    
                    </span>
                    
                    <br />
                    
                    <textarea className='calendarPlan' value={ this.state.task } onChange={ this.changeFx } onKeyDown={ this.enterFx } ></textarea>

                </div>

            </React.Fragment>
        )
        
   
    }
}


// WEBPACK FOOTER //
// ./src/components/calendar/CalendarCell.js